<template>
  <div class="UEditor">
    <slot></slot>
    <div class="chooseTem" :class="{disabled: !can_edit}" @click="chooseTemplate">选择点评语模板</div>
    <div class="UEditor__wrapper" style="position: relative;">
      <div class="customButton mediaButton" title="关联视频" @click="attachmentVideo(1)" v-show="can_edit"></div>
      <div class="customButton videoButton" title="录制视频" @click="attachmentVideo(2)" v-show="can_edit"></div>
      <div class="customButton voiceButton" :class="{disabled: part_audio.media_id}" title="录制音频" @click="attachmentAudio" v-show="can_edit"></div>
      <div class="customButton attachmentButton" title="附件" @click="addAttachment" v-show="can_edit"></div>
      <input type="file" id="partfile" multiple="multiple" @change="handleSelectFiles" hidden />
      <el-dialog
       :append-to-body="true"
        title="调用媒资平台内容"
        :visible.sync="mediaDialogVisible"
        custom-class="mediaDialog"
        width="30%">
        <el-form :model="videoForm" ref="form">
          <el-form-item label="Media-id" prop="media_id" :rules="rules">
            <el-input v-model="videoForm.media_id" autocomplete="off" @input="inputErrorMessage = false"></el-input>
            <div v-if="inputErrorMessage" class="inputErrorMessage">Media-ID不存在</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="mediaDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="check_media">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="点评语模板" :visible.sync="default_flag">
        <div class="defaultTip">（应用后，将在鼠标位置插入默认点评语）</div>
        <el-radio style="marginBottom: 10px; display: block;" v-for="(v, k) in defaultCommentsList" :key="k" v-model="defaultComments" :label="k">{{v}}</el-radio>
        <div style="font-size: 14px; color: red;">请选择点评语模板</div>
        <span slot="footer" class="dialog-footer" v-show="can_edit">
          <el-button @click="default_flag = false">取 消</el-button>
          <el-button type="primary" @click="apply">应用</el-button>
        </span>
      </el-dialog>
      <vue-ueditor-wrap v-model="part_comments" :config="myConfig" @ready="ready" ref="partComments"></vue-ueditor-wrap>
      <div class="attachment-wrapper" v-show="part_upload.media_id || part_audio.media_id || part_attachmentFilesList.length > 0">
        <div class="left attachmentTitle">附件:</div>
        <!-- 视频附件 -->
        <div class="left" v-show="part_upload.media_id">
          <el-popover
            placement="top-start"
            width="230"
            popper-class="attachment-pop"
            trigger="hover"
            v-model="part_upload.popFlag">
            <p class="attachmentName">
              <table>
                <tr>
                  <td class="popIcon video"></td>
                  <td class="popContent">{{part_upload.media_name || part_upload.media_id}}</td>
                </tr>
              </table>
              <span class="loadingTip" v-if="video_upload_status === 1">上传媒资平台中</span>
              <span class="loadingTip err" v-if="video_upload_status === 2">上传媒资平台失败</span>
            </p>
            <div class="attachmentOperation" v-if="video_upload_status != 1">
              <span @click="viewVideo">{{(video_upload_status === 0 || video_upload_status === 3) ? '查看' : '重试'}}</span>
              <span @click="delVideo" v-show="can_edit">删除</span>
            </div>
            <div class="attachmentOperation" v-if="video_upload_status === 1">
              <p class="loadingTip">上传不可中断，请耐心等待</p>
            </div>
            <span class="attachmentIcon video" slot="reference">
              <i class="statusIcon">
                <img v-if="video_upload_status === 1" src="./img/loading.png" />
                <img v-if="video_upload_status === 2" src="./img/error.png" />
              </i>
            </span>
          </el-popover>
        </div>
        <!-- 音频附件 -->
        <div class="left" v-show="part_audio.media_id">
          <el-popover
            placement="top-start"
            width="230"
            popper-class="attachment-pop"
            trigger="hover"
            v-model="part_audio.popFlag">
            <p class="attachmentName">
              <table>
                <tr>
                  <td class="popIcon audio"></td>
                  <td class="popContent">{{part_audio.media_name || part_audio.media_id}}</td>
                </tr>
              </table>
              <span class="loadingTip" v-if="audio_upload_status === 1">上传媒资平台中</span>
              <span class="loadingTip err" v-if="audio_upload_status === 2">上传媒资平台失败</span>
            </p>
            <div class="attachmentOperation" v-if="audio_upload_status != 1">
              <span @click="viewAudio">{{(audio_upload_status === 0 || audio_upload_status === 3) ? '查看' : '重试'}}</span>
              <span @click="delAudio" v-show="can_edit">删除</span>
            </div>
            <div class="attachmentOperation" v-if="audio_upload_status === 1">
              <p class="loadingTip">上传不可中断，请耐心等待</p>
            </div>
            <span class="attachmentIcon audio" slot="reference">
              <i class="statusIcon">
                <img v-if="audio_upload_status === 1" src="./img/loading.png" />
                <img v-if="audio_upload_status === 2" src="./img/error.png" />
              </i>
            </span>
          </el-popover>
        </div>
        <!-- 其他格式附件 -->
        <div class="left" v-show="part_attachmentFilesList.length > 0">
          <div class="left" v-for="(item, index) in part_attachmentFilesList" :key="index">
            <el-popover
              placement="top-start"
              width="230"
              popper-class="attachment-pop"
              trigger="hover"
              v-model="item.pop_flag">
              <p class="attachmentName">
                <table>
                  <tr>
                    <td class="popIcon" :class="[item.type_icon]"></td>
                    <td class="popContent">{{item.file_name}}</td>
                  </tr>
                </table>
                <span class="loadingTip" v-if="item.loading">上传中</span>
              </p>
              <div class="attachmentOperation" v-if="!item.loading">
                <span @click="viewAttachment(item.file_url, item.type_icon, item.media_id)">{{(item.type_icon === 'pic' || item.type_icon === 'pdf' || item.type_icon === 'video' || item.type_icon === 'audio') ? '查看' : '下载'}}</span>
                <span @click="delAttachment(index)" v-show="can_edit">删除</span>
              </div>
              <div class="attachmentOperation" v-if="item.loading">
                <p class="loadingTip">上传不可中断，请耐心等待</p>
              </div>
              <span class="attachmentIcon" :class="[item.type_icon]" slot="reference">
                <i class="statusIcon">
                  <img v-if="item.loading" src="./img/loading.png" />
                  <img v-if="!item.loading && !item.success" src="./img/error.png" />
                </i>
              </span>
            </el-popover>
          </div>
        </div>
      </div>
      <record-video :value.sync="RecordVideo" :maxRecordTime="300" @uploadFile="videoUpload" @errorLister="errorLister" :fullscreen="true"></record-video>
      <record-audio :value.sync="RecordAudio" :maxRecordTime="300" @uploadFile="videoUpload" @errorLister="errorLister" :fullscreen="true"></record-audio>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import RecordVideo from '@/components/record-video'
import RecordAudio from '@/components/record-video/audio'
import * as qiniu from 'qiniu-js'
import { SERVER_BASE_URL } from '@/api/api'
import '../../../static/ueditor/themes/iframe.css'

export default {
  watch: {
    '$route' (to, from) {
      if (this.$route.params.exercise_id || this.$route.params.record_id || this.$route.params.comment_type || this.$route.params.level_no || this.$route.params.comment_object_id) {
        this.getExerciseCorrectRet()
      }
    }
  },
  components: {
    VueUeditorWrap,
    RecordVideo,
    RecordAudio
  },
  props: ['allCommentsDialog'],
  computed: {
    part_comments: {
      get () {
        return this.$store.state.app.part_comments
      },
      set (value) {
        this.$store.commit('setPartComments', value)
      }
    },
    part_upload: {
      get () {
        return this.$store.state.app.part_upload
      },
      set (value) {
        this.$store.commit('setPartUpload', value)
      }
    },
    part_audio: {
      get () {
        return this.$store.state.app.part_audio
      },
      set (value) {
        this.$store.commit('setPartAudio', value)
      }
    },
    part_attachmentFilesList: {
      get () {
        return this.$store.state.app.part_attachmentFilesList
      },
      set (value) {
        this.$store.commit('setPartAttachmentFilesList', value)
      }
    },
    part_selectedFiles: {
      get () {
        return this.$store.state.app.part_selectedFiles
      },
      set (value) {
        this.$store.commit('setPartSelectedFiles', value)
      }
    }
  },
  data () {
    return {
      defaultComments: '0',
      defaultCommentsList: {
        '0': '作业已收到，请继续保持。',
        '1': '作答完整，继续加油哦',
        '2': '作业已完成，继续努力'
      },
      visible: false,
      default_flag: false,
      RecordVideo: false,
      RecordAudio: false,
      uploadAudio: false,
      sts: {
        accessKeyID: '',
        secretAccessKey: '',
        sessionToken: '',
        url: '',
        endpoint: ''
      },
      qiniuToken: '',
      mediaDialogVisible: false,
      videoForm: {
        media_id: ''
      },
      rules: [
        { required: true, message: '请输入Media-id' }
      ],
      inputErrorMessage: false,
      msg: '',
      myConfig: {
        readonly: false,
        enableAutoSave: false,
        saveInterval: 1000000,
        initialFrameHeight: 160,
        elementPathEnabled: false, // 不显示元素路径
        zIndex: 9,
        maximumWords: 1000,
        wordCount: true,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: 'http://35.201.165.105:8000/controller.php',
        serverUrl: SERVER_BASE_URL + '/api/api/index',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/static/ueditor/',
        toolbars: [[
          'bold',
          'italic',
          'forecolor',
          // 'insertimage',
          // 'underline',
          'simpleupload',
          // 'spechars',
          // 'kityformula',
          // 'fontpoint',
          // 'emptyunderline',
          'kityformula',
          'emotion'
          // 'attachment'
        ]]
      },
      attachmentRecordVideo: null,
      ossToken: null,
      client: null,
      video_upload_status: 0,
      audio_upload_status: 0,
      can_edit: true
    }
  },
  created () {
    this.myConfig.UEDITOR_HOME_URL = '/static/ueditor/'
    this.getQiniuToken()
    this.getOssToken()
    this.getExerciseCorrectRet()
    if (this.$route.params.correct_user.indexOf(localStorage.getItem('user_no')) != -1) {
      this.can_edit = true
    } else {
      this.can_edit = false
    }
  },
  mounted () {
    this.msg = this.part_comments
    this.myConfig.readonly = !this.can_edit
  },
  methods: {
    chooseTemplate () {
      if (!this.can_edit) {
        return
      }
      this.default_flag = true
    },
    apply () {
      const choosedTem = this.defaultCommentsList[this.defaultComments]
      this.$refs['partComments'].editor.focus()
      this.$refs['partComments'].editor.execCommand('inserthtml', choosedTem)
      this.default_flag = false
    },
    ready (editorInstance) {
      // this.$nextTick(() => {
      //   console.log(editorInstance.getContent())
      // })
      // editorInstance.execCommand('forecolor', 'black')
    },
    getQiniuToken () {
      this.$api.GETQINIUTOKEN({}).then(res => {
        console.log(res)
        if (res.retcode === 0) {
          this.qiniuToken = res.data
        } else {
          this.$message.error(res.message)
        }
      }).catch(error => {
        this.$message.error(error)
      })
    },
    getOssToken () {
      this.$api.GETOSSTOKEN({}).then(res => {
        const { AccessKeyId, AccessKeySecret, Expiration, SecurityToken } = res
        this.ossToken = { AccessKeyId, AccessKeySecret, Expiration, SecurityToken }
        const OSS = require('ali-oss')
        this.client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: AccessKeyId,
          accessKeySecret: AccessKeySecret,
          stsToken: SecurityToken,
          bucket: 's-eoffcn-com'
        })
      }).catch(error => {
        this.$message.error(error)
      })
    },
    // 获取点评内容
    getExerciseCorrectRet () {
      this.part_comments = ''
      this.part_upload.media_id = ''
      this.part_upload.url = ''
      this.part_audio.media_id = ''
      this.part_audio.url = ''
      this.part_attachmentFilesList = []
      const { exercise_id, record_id, comment_type, level_no, comment_object_id, object_type } = this.$route.params
      let params = {
        exercise_id: exercise_id,
        record_id: record_id,
        comment_type: comment_type,
        level_no: level_no,
        comment_object_id: comment_object_id,
        object_type: object_type
      }
      if (this.allCommentsDialog) { // 整体点评
        params.comment_type = 0
        params.level_no = 0
        params.comment_object_id = ''
      }
      params.correct_from = this.$route.query.correct_from ? this.$route.query.correct_from : 1
      this.$api.GETEXERCISECORRECTRET(params).then(res => {
        console.log('点评返回', res)
        if (res.retcode === 0) {
          let result = res.data
          this.part_comments = result.remark || ''
          this.part_attachmentFilesList = []
          if (result.appendant && result.appendant.length > 0) {
            for (let i = 0; i < result.appendant.length; i++) {
              if (result.appendant[i].file_type === 1) { // 视频
                let part_upload = {
                  media_id: result.appendant[i].media_id,
                  url: result.appendant[i].file_url
                }
                this.part_upload = part_upload
              } else if (result.appendant[i].file_type === 2) { // 音频
                let part_audio = {
                  media_id: result.appendant[i].media_id,
                  url: result.appendant[i].file_url
                }
                this.part_audio = part_audio
              } else if (result.appendant[i].file_type === 3 || result.appendant[i].file_type === 0) { // 附件
                let attachmentFile = result.appendant[i]
                attachmentFile.loading = false
                attachmentFile.success = true
                attachmentFile.pop_flag = false
                attachmentFile.pop_flag2 = false
                this.part_attachmentFilesList.push(attachmentFile)
              }
            }
          }
          this.part_selectedFiles = this.part_attachmentFilesList
        } else {
          this.$message.error(res.message)
        }
      }).catch(error => {
        this.$message.error(error)
      })
    },
    // 录制音频
    attachmentAudio () {
      if (this.part_audio.media_id) {
        return
      }
      this.RecordAudio = true
      this.uploadAudio = true
    },
    // 关联视频
    attachmentVideo (flag) {
      this.uploadAudio = false
      if (this.part_upload.media_id) {
        this.$confirm('该操作会导致原视频被覆盖，确定要继续吗？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'video-know-position',
          dangerouslyUseHTMLString: true,
          showClose: false,
          showCancelButton: true,
          closeOnClickModal: false,
          type: 'error'
        }).then(() => {
          if (flag === 1) {
            // 重新关联Media-id
            this.mediaDialogVisible = true
          } else {
            // 重新录制视频
            this.RecordVideo = true
          }
        }).catch(() => {
        })
      } else {
        if (flag === 1) {
          // 关联Media-id
          this.mediaDialogVisible = true
        } else {
          // 录制视频
          this.RecordVideo = true
        }
      }
    },
    // 关联Media-id
    check_media () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.GETMEDIAURL({mediaId: this.videoForm.media_id}).then(res => {
            if (res.retcode === 0) {
              this.part_upload.media_id = res.data.id
              this.part_upload.url = ''
              this.mediaDialogVisible = false
              this.videoForm.media_id = ''
            } else if (res.retcode === 10005 && res.message.indexOf('媒资不存在') > -1) {
              this.inputErrorMessage = true
            } else {
              this.$message.error(res.message)
            }
          }).catch(error => {
            console.log(error)
          })
        }
      })
    },
    // 视频上传
    videoUpload (obj) {
      console.log('视频---------->', obj);
      if (this.uploadAudio) {
        this.part_audio.file = obj
        this.part_audio.type = 2
        this.fileUploadQiNiu(obj, 1, 'audio')
      } else {
        this.part_upload.file = obj
        this.part_upload.type = 1
        this.fileUploadQiNiu(obj, 1, 'video')
      }
    },
    // 录制视频组件错误处理器
    errorLister (err) {
      console.log(err);
      this.$confirm(err.message, err.title, {
        confirmButtonText: '我知道了',
        type: 'warning',
        // center: true,
        showClose: false,
        showCancelButton: false
      }).then(() => {
      }).catch(() => {
      });
    },
    mediaCreate (type, fetchKey, name, mediaType, index) {
      // mediaType video(录制) 、 audio(录制) 、attachmentVideo(附件)、attachemtAudio(附件)
      let params = {
        type, // 10 视频 11 音频
        name,
        fetchKey
      }
      this.$api.MEDIACREATE(params).then(res => {
        console.log(res)
        if (res.retcode === 0) {
          switch (mediaType) {
            case 'video':
              this.part_upload.media_id = res.data.id
              this.part_upload.url = ''
              break
            case 'audio':
              this.part_audio.media_id = res.data.id
              this.part_audio.url = ''
              break
            case 'attachmentVideo':
              this.part_attachmentFilesList[index].media_id = res.data.id
              this.part_attachmentFilesList[index].file_url = ''
              break
            case 'attachmentAudio':
              this.part_attachmentFilesList[index].media_id = res.data.id
              this.part_attachmentFilesList[index].file_url = ''
              break
            default:
              break
          }
        } else {
          this.$message.error(res.message)
        }
      }).catch(error => {
        this.$message.error(error)
      })
    },
    fileUploadQiNiu (file, type, mediaType, index) {
      if (this.uploadAudio) {
        this.part_audio.media_id = null
        this.part_audio.url = null
        this.audio_upload_status = 1
      } else {
        this.part_upload.media_id = null
        this.part_upload.url = null
        this.video_upload_status = 1
      }
      let file_name = ''
      let file_blob = ''
      if (type == 1){
          file_name  = '录制视频'
          if (this.uploadAudio) {
            file_name  = '录制音频'
          }
          file_blob = file.blob;
      } else {
          file_name  = file.name;
          file_blob = file;
      }
      let that = this
      console.log(file_name)
      const key = `upload/${this.getFolderName()}/${new Date().getTime()}/${file_name}`
      const observable = qiniu.upload(file_blob, key, this.qiniuToken)
      const observer = {
        next(res){
        },
        error(err){
          console.log('err::', res)
          if (mediaType === 'video') {
            that.video_upload_status = 2
          }
          if (mediaType === 'audio') {
            that.audio_upload_status = 2
          }
          if (index) {
            that.part_attachmentFilesList[index].loading = false
          }
        },
        complete(res){
          console.log('complete::', res)
          // if (mediaType === 'video' || mediaType === 'attachmentVideo') {
          //   that.mediaCreate(10, res.key, file_name, mediaType)
          // } else {
          //   that.mediaCreate(11, res.key, file_name, mediaType)
          // }
          switch (mediaType) {
            case 'video':
              that.video_upload_status = 3
              that.mediaCreate(10, res.key, file_name, mediaType)
              break
            case 'attachmentVideo':
              that.mediaCreate(10, res.key, file_name, mediaType, index)
              break
            case 'audio':
              that.audio_upload_status = 3
              that.mediaCreate(11, res.key, file_name, mediaType)
              break
            case 'attachmentAudio':
              that.mediaCreate(11, res.key, file_name, mediaType, index)
              break
            default:
              break
          }
          console.log(typeof(index) === 'number')
          if (typeof(index) === 'number') {
            that.part_attachmentFilesList[index].loading = false
            that.part_attachmentFilesList[index].success = true
          }
        }
      }
      const subscription = observable.subscribe(observer) // 上传开始
    },
    getNumber () {
        return Math.floor(Math.random() * (99999 - 10000)) + 10000
    },
    viewVideo () {
      if (this.video_upload_status === 2) {
        this.fileUploadQiNiu(this.part_upload.file, 1, 'video')
      } else {
        let vidoe_window = window.open('')
        let href =  this.$router.resolve({
          path: '/video-preview/' + this.part_upload.media_id
        })
        vidoe_window.location = href.href
      }
    },
    delVideo () {
      this.part_upload.media_id = ''
      this.part_upload.media_name = ''
    },
    viewAudio () {
      if (this.audio_upload_status === 2) {
        this.fileUploadQiNiu(this.part_audio.file, 1, 'audio')
      } else {
        let audio_window = window.open('')
        let href =  this.$router.resolve({
          path: '/video-preview/' + this.part_audio.media_id
        })
        audio_window.location = href.href
      }
    },
    delAudio () {
      this.part_audio.media_id = ''
      this.part_audio.media_name = ''
    },
    viewPic () {
      document.getElementsByClassName('el-image__inner el-image__preview')[0].click()
      document.getElementsByClassName('el-image-viewer__btn el-image-viewer__close')[0].addEventListener('click', () => {
        document.getElementsByClassName('el-image-viewer__wrapper')[0].style.display = 'none'
      }, false)
    },
    // 添加附件
    addAttachment () {
      document.getElementById('partfile').click()
    },
    // 生成日期目录
    getFolderName () {
      let date = new Date()
      return date.getFullYear() + ('0' + String(date.getMonth() + 1)).substr(-2) + ('0' + String(date.getDate())).substr(-2)
    },
    // 上传附件
    async handleSelectFiles () {
      const part_selectedFiles = document.getElementById('partfile').files
      console.log(part_selectedFiles)
      const lastIndex = this.part_selectedFiles.length
      this.part_selectedFiles = [...this.part_selectedFiles, ...part_selectedFiles]
      for (let i = lastIndex; i < this.part_selectedFiles.length; i++) {
        let typeIcon = 'other'
        let timeLength = 0
        const fileObj = {
          pop_flag: false,
          pop_flag2: false,
          file_name: this.part_selectedFiles[i].name,
          file_type: 3,
          is_lock: 0,
          loading: true,
          success: false,
          type_icon: typeIcon,
          time_length: timeLength,
          media_id: '',
          file_url: ''
        }
        if (this.part_selectedFiles[i].type.indexOf('image') > -1) {
          typeIcon = 'pic'
          fileObj.file_type = 0
        } else if (this.part_selectedFiles[i].type.indexOf('video') > -1) {
          typeIcon = 'video'
          fileObj.type_icon = typeIcon
          this.part_attachmentFilesList.push(fileObj)
          this.fileUploadQiNiu(this.part_selectedFiles[i], 2, 'attachmentVideo', this.part_attachmentFilesList.length - 1)
        } else if (this.part_selectedFiles[i].type.indexOf('audio') > -1) {
          typeIcon = 'audio'
          const audioUrl = URL.createObjectURL(this.part_selectedFiles[i])
          const audioElement = new Audio(audioUrl)
          audioElement.addEventListener('loadedmetadata', (_event) => {
              timeLength = parseInt(audioElement.duration)
              fileObj.time_length = timeLength
          })
          fileObj.type_icon = typeIcon
          this.part_attachmentFilesList.push(fileObj)
          this.fileUploadQiNiu(this.part_selectedFiles[i], 2, 'attachmentAudio', this.part_attachmentFilesList.length - 1)
        } else if (this.part_selectedFiles[i].type.indexOf('pdf') > -1) {
          typeIcon = 'pdf'
        } else if (this.part_selectedFiles[i].type.indexOf('application/msword') > -1 || this.part_selectedFiles[i].type.indexOf('application/vnd.openxmlformats-officedocument.wordprocessingml.document') > -1) {
          typeIcon = 'word'
        } else if (this.part_selectedFiles[i].type.indexOf('application/vnd.ms-excel') > -1 || this.part_selectedFiles[i].type.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') > -1) {
          typeIcon = 'excel'
        }
        if (typeIcon !== 'video' && typeIcon !== 'audio') {
          fileObj.type_icon = typeIcon
          this.part_attachmentFilesList.push(fileObj)
          let folderUrl = `/pigai/exercise/${this.getFolderName()}/`
          folderUrl = `${folderUrl}${this.part_selectedFiles[i].name}`

          this.client.multipartUpload(folderUrl, this.part_selectedFiles[i]).then((result) => {
            console.log(result)
            let url = `https://s.eoffcn.com${folderUrl}`
            this.part_attachmentFilesList[i].file_url = url
            this.part_attachmentFilesList[i].loading = false
            this.part_attachmentFilesList[i].success = true
          }).catch((err) => {
            console.log(err)
            this.part_attachmentFilesList[i].loading = false
          })
        }
      }
    },
    // 查看 下载附件
    viewAttachment (url, typeIcon, mediaId) {
      if (typeIcon === 'video' || typeIcon === 'audio') {
        let audio_window = window.open('')
        let href =  this.$router.resolve({
          path: '/video-preview/' + mediaId
        })
        audio_window.location = href.href
        return
      }
      window.open(url)
    },
    // 锁定 解锁
    handleLock (index) {
      this.part_attachmentFilesList[index].locked = !this.part_attachmentFilesList[index].locked
    },
    // 删除附件
    delAttachment (index) {
      this.part_attachmentFilesList.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.UEditor{
  position: relative;
  overflow: hidden;
  .inputErrorMessage{
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
  }
  .chooseTem{
    position: absolute;
    right: 0;
    top: 0;
    font-size: 14px;
    color: #6594fe;
    cursor: pointer;
    &.disabled{
      color: #ccc;
      cursor: not-allowed;
    }
  }
  .customButton {
    position:absolute;
    top: 6px;
    cursor: pointer;
    z-index: 10;
    width: 20px;
    height: 20px;
    padding: 3px;
    background-repeat: no-repeat;
    background-position:center;
    &:hover{
      background-color: #ffe69f;
      border: 1px solid #dcac6c;
      border-radius: 2px;
    }
    &.mediaButton{
      background-image: url("./img/media-icon.png");
      right: 96px;
    }
    &.videoButton{
      background-image: url("./img/video-icon.png");
      width: 24px;
      right: 66px;
    }
    &.voiceButton{
      background-image: url("./img/voice-icon.png");
      right: 36px;
      &.disabled{
        background-image: url("./img/voice_disabled.png");
        &:hover{
          background-color: #ffffff;
          border: none;
          border-radius: 0;
        }
      }
    }
    &.attachmentButton{
      background-image: url("./img/attachment-icon.png");
      right: 10px;
    }
  }
  p{
    font-size: 14px;
    line-height: 14px;
    color: #2a2e3d;
    font-weight: bold;
    background: url("./img/icon.png") no-repeat;
    padding-left: 14px;
    margin-top: 0;
  }
  .attachment-wrapper{
    border: 1px solid #d4d4d4;
    border-top: 0;
    overflow: hidden;
    padding: 10px 20px 5px 0px;
    .left{
      float: left;
    }
    .attachmentTitle{
      font-size: 14px;
      padding-top: 2px;
      padding-left: 20px;
    }
  }
}
.attachment-pop{
  padding: 0;
  .attachmentName{
    padding: 0;
    margin:0;
    padding: 10px 20px;
    .loadingTip{
      display: inline-block;
      font-size: 12px;
      color: #6594fe;
      padding: 3px 16px;
      background-color: #e0eefd;
      border-radius: 2px;
      margin-top: 6px;
    }
  }
  .attachmentOperation{
    height: 28px;
    line-height: 28px;
    display: flex;
    border-top: 1px solid #e6e6e6;
    .loadingTip{
      width: 100%;
      margin: 0;
      text-align: center;
      color: #7d829a;
      font-size: 12px;
      line-height: 26px;
    }
    span{
      flex: 1;
      text-align: center;
      border-right: 1px solid #e6e6e6;
      font-size: 12px;
      cursor: pointer;
      &:last-child{
        border-right: 0;
      }
    }
  }
}
.attachmentIcon{
  width: 24px;
  height: 24px;
  background-color: #fafafa;
  border-radius: 4px;
  border: solid 1px #e6e7e8;
  background-position: center;
  background-repeat: no-repeat;
  display: inline-block;
  cursor: pointer;
  margin-left: 10px;
  position: relative;
  .statusIcon{
    position: absolute;
    right: -1px ;
    bottom: -4px;
  }
  &.pic{
    background-image: url("./img/pic.png");
    &:hover{
      background-image: url("./img/pic_on.png");
    }
  }
  &.video{
    background-image: url("./img/video.png");
    &:hover{
      background-image: url("./img/video_on.png");
    }
  }
  &.audio{
    background-image: url("./img/audio.png");
    &:hover{
      background-image: url("./img/audio_on.png");
    }
  }
  &.word{
    background-image: url("./img/word.png");
    &:hover{
      background-image: url("./img/word_on.png");
    }
  }
  &.excel{
    background-image: url("./img/excel.png");
    &:hover{
      background-image: url("./img/excel_on.png");
    }
  }
  &.pdf{
    background-image: url("./img/pdf.png");
    &:hover{
      background-image: url("./img/pdf_on.png");
    }
  }
  &.other{
    background-image: url("./img/other.png");
    &:hover{
      background-image: url("./img/other_on.png");
    }
  }
}
.popIcon{
  width: 20px;
  height: 20px;
  background-position: center 4px;
  background-repeat: no-repeat;
  &.pic{
    background-image: url("./img/pic_on.png");
  }
  &.video{
    background-image: url("./img/video_on.png");
  }
  &.audio{
    background-image: url("./img/audio_on.png");
  }
  &.word{
    background-image: url("./img/word_on.png");
  }
  &.excel{
    background-image: url("./img/excel_on.png");
  }
  &.pdf{
    background-image: url("./img/pdf_on.png");
  }
  &.other{
    background-image: url("./img/other_on.png");
  }
}
.popContent{
  padding-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ueditor/part-comments.vue